import indentationStyles from './indentation.scss';

const INDENT_STEP = parseInt(indentationStyles['indent-step']);
const INDENT_STEP_MOBILE = parseInt(indentationStyles['indent-step-mobile']);

let maxIndent = 10;
let sheet: CSSStyleSheet | undefined;

function getStyleSheet(): CSSStyleSheet {
  if (sheet) {
    return sheet;
  }
  const style = document.createElement('style');
  document.head.appendChild(style);
  sheet = style.sheet as CSSStyleSheet;
  return sheet;
}

function generateClasses(indent: number, isMobile: boolean) {
  if (indent <= maxIndent || typeof document === 'undefined') {
    return;
  }
  const css = getStyleSheet();
  const indentStep = isMobile ? INDENT_STEP_MOBILE : INDENT_STEP;
  for (let i = maxIndent + 1; i <= indent; i++) {
    const margin = indentStep * i;
    css.insertRule(`._comment-thread-indent-${i} { margin-left: ${margin}px }`);
  }
  maxIndent = indent;
}

export function getIndentClassName(
  indent: number,
  isMobile: boolean | undefined
) {
  if (indent <= 10) {
    return indentationStyles[`indent-${indent}`];
  }
  generateClasses(indent, !!isMobile);
  return `_comment-thread-indent-${indent}`;
}
